module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kc-Lb.0a494f31.png";